export default "__VITE_ASSET__1f11130b__"